import React, { useState,useEffect} from "react";
import Style from "./LiveLocation.module.css";
import LiveLocationMap from "../../Components/LiveLocationMap/LiveLocationMap";
import { getDeliverInfoApi } from "../../Api/SupplierServices";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

const LiveLocation = (props) => {
  console.log(props.location.state)
  const [data,setData]=useState()
  useEffect(()=>{
    getDeliverInfo()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])
  const getDeliverInfo=async()=>{
    const result=await getDeliverInfoApi(props.location.state)
    setData(result.delivery)
  }
  let history=useHistory()
  // http://cdn.ir/deliver/photo/${data&&data.photo}.jpg
  return (
    <div className={Style.DivHolder}>
      <div className={Style.ComponentHolder}>
        <div></div>
        <h3>اطلاعات پیک</h3>
        <div onClick={() => history.goBack()}><FontAwesomeIcon icon={faArrowRight} style={{fontSize:"1.4rem"}}/></div>
      </div>
      <LiveLocationMap orderId={props.location.state}/>
      <div className={Style.deliverInfoHolder}>
        <div className={Style.deliverInfo}>
          <div className={Style.picHolder}>
            <img src={`http://cdn.barest.ir/deliver/photo/${data&&data.photo}.jpg`} alt=""/>
          </div>
          <h2 className={Style.fullName}>{data&&data.full_name}</h2>
        </div>
      </div>
    </div>
  );
};
export default LiveLocation;
